import {
    createApp
} from 'vue';
import App from './App.vue';
import store from './store';
import i18n from './locale';
import router from './router';
import interceptorsSetup from './repositories/interceptor.js';
import globalFunctions from './helpers/global_functions.js';
import resizeMixin from './helpers/resizeMixin.js';
import globalVars from './config/global_vars.js';
import AppLayout from './layouts/AppLayout'
import 'bootstrap';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-next-select/dist/index.min.css'
import './scss/theme.scss';
import VueCookies from 'vue3-cookies';
import {
    OhVueIcon,
    addIcons
} from "oh-vue-icons";
import 'v-calendar/dist/style.css';
import {
  MdManageaccountsOutlined,
  IoLockClosedOutline,
  BiBoxes,
  OiXCircle,
  OiCheckCircle,
  HiPlus,
  HiMinus,
  FaCaretDown,
  FaCaretUp,
  FaEnvelope,
  FaChevronRight,
  FaRegularCheckCircle,
  CoExitToApp,
  FaUser,
  FaStore,
  FaRegularBuilding,
  OiThreeBars,
  RiCalendarLine,
  FaChevronDown,
  FaChevronUp,
  HiSolidChevronDown,
  BiDownload,
  FaEllipsisV,
  IoDocumentText,
  FaRegularUser,
  FaMobileAlt,
  RiBarChartBoxLine,
  BiGlobe,
  FaBuilding,
  BiShopWindow,
  BiExclamationTriangle,
  OiSearch,
  HiClipboardList,
  MdDeleteRound,
  MdModeeditoutline,
  MdCancelOutlined,
  BiPlusCircle,
  LaMinusCircleSolid,
  MdSearchoff,
  IoWarningOutline,
  BiXCircle,
  MdErroroutline,
  LaShoppingCartSolid,
  BiChevronDown,
  BiChevronUp,
  BiUpload,
  BiFiletypeCsv,
  BiPercent,
  MdAutorenew,
  OiX,
  MdLocalprintshopOutlined,
  BiFilter,
  MdNotificationsactiveRound,
  CoReload,
  BiFileEarmarkText,
  BiCheckCircle,
  HiXCircle,
  BiCart2,
  BiSearch,
  BiPlayFill,
  BiGraphUp,
  BiHourglassSplit,
  MdTimeline,
  BiBell,
  MdSchedule,
  MdChevronright,
  BiListUl,
  BiWallet2,
  BiReceipt,
} from "oh-vue-icons/icons"
import {
    Amplify
} from 'aws-amplify';
import awsconfig from './aws-exports';

const icons = Object.values({
  MdManageaccountsOutlined,
  IoLockClosedOutline,
  BiBoxes,
  OiXCircle,
  OiCheckCircle,
  HiPlus,
  HiMinus,
  FaCaretDown,
  FaCaretUp,
  FaEnvelope,
  FaChevronRight,
  FaRegularCheckCircle,
  CoExitToApp,
  FaUser,
  FaStore,
  FaRegularBuilding,
  OiThreeBars,
  RiCalendarLine,
  FaChevronDown,
  FaChevronUp,
  HiSolidChevronDown,
  BiDownload,
  FaEllipsisV,
  IoDocumentText,
  FaRegularUser,
  FaMobileAlt,
  RiBarChartBoxLine,
  BiGlobe,
  FaBuilding,
  BiShopWindow,
  BiExclamationTriangle,
  OiSearch,
  HiClipboardList,
  MdDeleteRound,
  MdModeeditoutline,
  MdCancelOutlined,
  BiPlusCircle,
  LaMinusCircleSolid,
  MdSearchoff,
  IoWarningOutline,
  BiXCircle,
  MdErroroutline,
  LaShoppingCartSolid,
  BiChevronDown,
  BiChevronUp,
  BiUpload,
  BiFiletypeCsv,
  BiPercent,
  MdAutorenew,
  OiX,
  MdLocalprintshopOutlined,
  BiFilter,
  MdNotificationsactiveRound,
  CoReload,
  BiFileEarmarkText,
  BiCheckCircle,
  HiXCircle,
  BiCart2,
  BiSearch,
  BiPlayFill,
  BiGraphUp,
  BiHourglassSplit,
  MdTimeline,
  BiBell,
  MdSchedule,
  MdChevronright,
  BiListUl,
  BiWallet2,
  BiReceipt,
})
addIcons(...icons);

Amplify.configure(awsconfig);

interceptorsSetup()

const app = createApp(App).use(VueCookies).use(store).use(i18n).use(router).use(globalFunctions).use(globalVars).mixin(resizeMixin);

app.component("v-icon", OhVueIcon);
app.component('AppLayout', AppLayout);

app.mount('#app')

setInterval(() => {
    const toastContainer = document.getElementById('toast-container');
    const toastErrorContainer = document.getElementById('toast-error-container');
    if (localStorage.getItem('downloadCSV') === "true") {
        toastContainer.style.opacity = "1";
        toastContainer.style.display = "block";
    } else if (localStorage.getItem('downloadCSV') === "false") {
        toastContainer.style.opacity = "0";
        toastContainer.style.display = "none";
        localStorage.removeItem('downloadCSV');
        if (localStorage.getItem('errorDownloadCSV') === "true") {
            toastErrorContainer.style.opacity = "1";
            toastErrorContainer.style.display = "block";
        } else if (localStorage.getItem('errorDownloadCSV') === "false") {
            toastErrorContainer.style.opacity = "0";
            toastErrorContainer.style.display = "none";
            localStorage.removeItem('errorDownloadCSV');
        }
    }
}, 100)

if (document.getElementById('closeToast') !== null) {
    document.getElementById('closeToast').onclick = function () {
        localStorage.setItem('downloadCSV', false);
    };
}

if (document.getElementById('closeErrorToast') !== null) {
    document.getElementById('closeErrorToast').onclick = function () {
        const toastErrorContainer = document.getElementById('toast-error-container');
        localStorage.setItem('errorDownloadCSV', false);
        toastErrorContainer.style.opacity = "0";
        toastErrorContainer.style.display = "none";
        localStorage.removeItem('errorDownloadCSV');
    };
}